export const needsConfirmation = async ({
    confirmDialog, 
    actionName = "exit", 
    message = "Your changes have not been saved",
    buttons = {
        confirmLabel: "Yes",
    }
}) => {
    return await confirmDialog.show({
        actionName,
        message,
        buttons,
    });
}
